import { render, staticRenderFns } from "./UpdateRegion.vue?vue&type=template&id=0ba86120&scoped=true"
import script from "./UpdateRegion.vue?vue&type=script&lang=js"
export * from "./UpdateRegion.vue?vue&type=script&lang=js"
import style0 from "./UpdateRegion.vue?vue&type=style&index=0&id=0ba86120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba86120",
  null
  
)

export default component.exports